import {createTheme} from "@material-ui/core/styles";

export default createTheme({
    overrides: {
        MuiPaper: {
            root: {
                backgroundColor: '#f5f5f5',
                padding: '0',
            },
            elevation2: {
                boxShadow: '0 0 0 0',
            },
        }
    },
});